import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeta = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 22V8C8.5 5.6 10 4 12.2 4C14.4 4 16 5.4 16 7.5C16 9.6 14.4 11 12 11H8.5M12 11C14.4 11 16.2 12.5 16.2 14.8C16.2 17 14.7 18.7 12.6 18.7C11.3 18.7 10.2 18.2 9.5 17.4",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBeta;
